import { $host } from ".";

// Get all feedbacks
export const fetchFeedbacks = async () => {
    try {
        const { data } = await $host.get("api/feedback");
        return data;
    } catch (error) {
        console.error("Error fetching feedbacks:", error);
        return error;
    }
};

// Get one feedback by ID
export const fetchFeedback = async (id) => {
    try {
        const { data } = await $host.get("api/feedback/id/" + id);
        return data;
    } catch (error) {
        console.error("Error fetching feedback:", error);
        return error;
    }
};

// Create new feedback (with image upload support)
export const createFeedback = async (feedback) => {
    try {
        const { data } = await $host.post("api/feedback", feedback, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error("Error creating feedback:", error);
        return error;
    }
};

// Update feedback 
export const updateFeedback = async (id, feedback) => {
    try {
        const { data } = await $host.put("api/feedback/" + id, feedback, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error("Error updating feedback:", error);
        return error;
    }
};

// Delete feedback
export const deleteFeedback = async (id) => {
    try {
        const { data } = await $host.delete("api/feedback/" + id);
        return data;
    } catch (error) {
        console.error("Error deleting feedback:", error);
        return error;
    }
};
